import { RegistriaSnippetResponse } from '../../models/registria/registria-snippet-response.interface';

export const mockRegistriaSnippetResponse: RegistriaSnippetResponse = {
  url: 'https://whirlpool-concierge.registriaqa.com/en-us/digital-concierge?t=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOjc5LCJzdWIiOjQ5NzE3NjIsInNjb3BlIjoiZGVmYXVsdCIsImV4cCI6MTc0MjgxODM2MCwiaWF0IjoxNzM3NjM0MzYwfQ.8PXI3wV0fOhnl01XSlJHF4ixGwIbpH9DiE2Jt49hTEs&regid=1628149',
  button_text: 'Access my Owner Info',
  header_text:
    'You can also access your Owner Info at any time through the following applicable method(s), which may include:',
  bullet_points: [
    'A QR code sticker attached to your product.',
    "A Photoregister Camera icon on a paper card in your product's packaging materials.",
    'A link we will send to your email.',
  ],
  message: 'Concierge setup retrieved for this product registration.',
  success: true,
};
